export enum PremiumPayFlagsEnum {
  DAY_MONDAY = 'DAY_MONDAY',
  DAY_TUESDAY = 'DAY_TUESDAY',
  DAY_WEDNESDAY = 'DAY_WEDNESDAY',
  DAY_THURSDAY = 'DAY_THURSDAY',
  DAY_FRIDAY = 'DAY_FRIDAY',
  DAY_SATURDAY = 'DAY_SATURDAY',
  DAY_SUNDAY = 'DAY_SUNDAY',
  DAY_HOLIDAY = 'DAY_HOLIDAY',
  DAY_HOLIDAY_SAT = 'DAY_HOLIDAY_SAT',
  DAY_HOLIDAY_SUN = 'DAY_HOLIDAY_SUN',
  DAY_SPECIAL = 'DAY_SPECIAL',
  TIME_FROM_THR = 'TIME_FROM_THR',
  TIME_TO_THR = 'TIME_TO_THR'
}

export interface PremiumPayType {
  code: string;
  claId: number;
  claSvc?: string;
  cla_ext: string;
}

export interface BonusType {
  id: number;
  code: string;
  description: string;
  groupId: number;
  name: string;
}

export interface Bonus25Method {
  id: number;
  groupId: number;
  code: string;
  name: string;
  description: string;
}

export interface PremiumPay {
  claBonusId: number;
  claId: number;
  percentage: number;
  timeFrom: string;
  timeTo: string;
  valid: {
    from: string;
    to: string;
  };
  bonusTypeSvc: string;
  flags: PremiumPayFlagsEnum[];
  columnNr: number;
  claCode: string;
  timeFromThr?: string;
  timeToThr?: string;
  scPri?: string;
  scSec?: string;
  bonus25Method?: string;
  bonusTypeSvcName?: string;
  maxHoursPerDayrange?: number;
  dayrange?: number;
}
